


































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import KepatuhanJatuhStore from "@/store/modules/KepatuhanJatuhStore";

@Component
export default class AlasanStep extends Vue {
  @Prop({ default: null }) session!: any;
  form: {
    alasan: string[];
    uraian_lengkap: string;
    rencana_tindak_lanjut_umum: string;
  } = { alasan: [], uraian_lengkap: "", rencana_tindak_lanjut_umum: "" };
  saving = false;
  error = "";

  alasanOpts = [
    { text: "Beban kerja tinggi", value: "beban_kerja" },
    { text: "Pasien menolak", value: "pasien_menolak" },
    { text: "Gangguan jiwa", value: "gangguan_jiwa" },
    { text: "Sistem error / gangguan IT", value: "sistem_error" },
    { text: "Pasien meninggal", value: "pasien_meninggal" },
    { text: "Lainnya", value: "lainnya" }
  ];

  get store() {
    return KepatuhanJatuhStore;
  }

  get capaianUnder100() {
    return this.session && Number(this.session.capaian_pct || 0) < 100;
  }

  get saveDisabled() {
    if (this.saving) return true;
    if (this.capaianUnder100 && this.form.alasan.length === 0) return true;
    return false;
  }

  @Watch("session", { immediate: true, deep: true })
  onSession(v: any) {
    if (v && v.alasan_session) {
      this.form = {
        alasan: v.alasan_session.alasan || [],
        uraian_lengkap: v.alasan_session.uraian_lengkap || "",
        rencana_tindak_lanjut_umum:
          v.alasan_session.rencana_tindak_lanjut_umum || ""
      };
    }
  }

  async save() {
    if (!this.session || !this.session.id) return;
    this.error = "";
    this.saving = true;
    try {
      await this.store.saveAlasan({
        id: this.session.id,
        data: this.form
      });
      this.$emit("saved");
    } catch (e) {
      this.error =
        e.response?.data?.message || e.message || "Gagal menyimpan alasan";
    } finally {
      this.saving = false;
    }
  }
}
